export const yearlyTotal = (monthly) => +(monthly * 12 * 0.9).toFixed(2);

export const fmtUsd = (n) => `$${Number.isInteger(n) ? n : n.toFixed(2)}`;

export const PeriodToggle = ({ value, onChange, testid = "billing-period-toggle" }) => (
  <div data-testid={testid} role="radiogroup" aria-label="Billing period" className="inline-flex rounded-full border border-[#2A2A2A] bg-[#050505] p-1 text-xs">
    {[["monthly", "Monthly"], ["yearly", "Yearly"]].map(([v, label]) => (
      <button key={v} type="button" role="radio" aria-checked={value === v} data-testid={`${testid}-${v}`} onClick={() => onChange(v)}
        className={`rounded-full px-4 py-1.5 transition-colors ${value === v ? "bg-[#00FF9D] text-[#050505] font-semibold" : "text-[#A3A3A3] hover:text-white"}`}>
        {label}{v === "yearly" && <span className={`ml-1.5 font-mono text-[10px] ${value === v ? "text-[#050505]" : "text-[#00FF9D]"}`}>-10%</span>}
      </button>
    ))}
  </div>
);

export const PriceTag = ({ monthly, period, big = "text-4xl", testid }) => (
  <div data-testid={testid}>
    <p className="font-mono">
      <span className={`${big} font-bold`}>{period === "yearly" ? fmtUsd(yearlyTotal(monthly)) : fmtUsd(monthly)}</span>
      <span className="text-[#A3A3A3]">{period === "yearly" ? "/yr" : "/mo"}</span>
    </p>
    <p className="mt-1 text-xs text-[#A3A3A3] min-h-[1rem]">
      {period === "yearly" ? <>Works out to {fmtUsd(+(monthly * 0.9).toFixed(2))}/mo · save {fmtUsd(+(monthly * 12 * 0.1).toFixed(2))} a year</> : "Billed monthly · discount codes accepted at checkout"}
    </p>
  </div>
);
